import { motion } from 'framer-motion'
import { Target, Eye, Lightbulb } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function AboutSection() {
  const { t } = useTranslation('home')
  return (
    <section id="about" className="about-section-gradient py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto mb-16"
        >
          <h2 className="about-title text-4xl sm:text-5xl font-bold mb-6">
            {t('about.title')}
          </h2>
          <p className="about-description text-xl leading-relaxed mb-8">
            {t('about.description')}
          </p>
          {t('about.positioning', { defaultValue: '' }) && (
            <p className="text-lg sm:text-xl font-semibold about-card-title leading-relaxed">
              {t('about.positioning')}
            </p>
          )}
        </motion.div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            {
              icon: Target,
              key: 'mission'
            },
            {
              icon: Eye,
              key: 'vision'
            },
            {
              icon: Lightbulb,
              key: 'values'
            }
          ].map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="about-card rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex justify-center mb-4">
                <div className="about-icon-bg p-3 rounded-lg">
                  <value.icon className="about-icon w-8 h-8" />
                </div>
              </div>
              <h3 className="about-card-title text-xl font-bold mb-3 text-center">
                {t(`about.${value.key}.title`)}
              </h3>
              <p className="about-card-text leading-relaxed">
                {t(`about.${value.key}.description`)}
              </p>
            </motion.div>
          ))}
        </div>

        {/* About Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-16 max-w-4xl mx-auto"
        >
          <div className="about-card rounded-xl p-8 sm:p-12 shadow-lg">
            <h3 className="about-card-title text-2xl sm:text-3xl font-bold mb-6">
              {t('about.whoWeAre.title')}
            </h3>
            <div className="space-y-4 about-card-text leading-relaxed">
              <p>
                {t('about.whoWeAre.paragraph1')}
              </p>
              <p>
                {t('about.whoWeAre.paragraph2')}
              </p>
              <p>
                {t('about.whoWeAre.paragraph3')}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
